import React from 'react';
import { Link } from 'react-router-dom';
import styles from './item.module.scss';

type Props = {
  key?: number,
  artist: IArtistItem
};

const ArtistItem: React.FC<Props> = ({ artist }) => {
  const artistLink = `/artist/${artist.id}`;

  return (
    <div className={styles.artistItem}>
      <div className={styles.imageContainer}>
        <div className={styles.image}>
          <Link to={artistLink}><img src={artist.avatar} alt={artist.name} /></Link>
        </div>
      </div>
      <div className={styles.info}>
        <h4 className={styles.title}>
          <Link to={artistLink}>
            {artist.hasBadge ? (
              <span className="text-secondary ms-2">
                <i className="fas fa-badge-check" />
              </span>
            ) : ''} {' '}
            {artist.name}
          </Link>
        </h4>
        <p className={styles.bio}>
          {artist.bio}
        </p>
      </div>
    </div>
  );
}

export default ArtistItem;
